import { render, staticRenderFns } from "./GalerijaAlbum.vue?vue&type=template&id=430715d0&scoped=true"
import script from "./GalerijaAlbum.vue?vue&type=script&lang=js"
export * from "./GalerijaAlbum.vue?vue&type=script&lang=js"
import style0 from "./GalerijaAlbum.vue?vue&type=style&index=0&id=430715d0&prod&lang=scss&scoped=true"
import style1 from "./GalerijaAlbum.vue?vue&type=style&index=1&id=430715d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430715d0",
  null
  
)

export default component.exports